var React = require('react');

function ImproveProductivity (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 43C32.8366 43 40 35.9113 40 27.1667C40 18.4221 32.8366 11.3333 24 11.3333C15.1634 11.3333 8 18.4221 8 27.1667C8 35.9113 15.1634 43 24 43ZM24.8 17.6667C24.8 16.7922 24.0837 16.0833 23.2 16.0833C22.3163 16.0833 21.6 16.7922 21.6 17.6667V25.5833C21.6 27.3323 23.0326 28.75 24.8 28.75H32C32.8837 28.75 33.6 28.0411 33.6 27.1667C33.6 26.2922 32.8837 25.5833 32 25.5833H24.8V17.6667Z","stroke":"#E8EFFF","strokeOpacity":"0.7","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M35.2 8H12.8V11.1667H35.2V8Z","stroke":"#E8EFFF","strokeOpacity":"0.7","strokeWidth":"1.5","key":1})]);
}

ImproveProductivity.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ImproveProductivity;

ImproveProductivity.default = ImproveProductivity;
